import { t } from 'i18next';
import * as yup from 'yup';

import { defaultActionOptions } from '@/components/organisms/Toolkit/ToolkitResponses/ToolkitActionCarousel/constants';

import { LENGTH_S, LENGTH_M, CAROUSEL_SUBTITLE_MAX_LENGTH } from '../constants';
import { slug } from '../patterns';
import { urlSchema } from '../schema-builders';

export const carouselCardSchema = yup.object().shape({
  title: yup
    .string()
    .max(LENGTH_S, () => t('validation.less_than', { 0: LENGTH_S }))
    .required(() => t('validation.required_field', { 0: t('common.title') })),
  subtitle: yup
    .string()
    .max(CAROUSEL_SUBTITLE_MAX_LENGTH, () =>
      t('validation.less_than', { 0: CAROUSEL_SUBTITLE_MAX_LENGTH })
    ),
  media: yup.object().shape({ url: urlSchema, type: yup.string().oneOf(['image', 'video']) }),
});

const defaultCarouselButtonSelectOptions = defaultActionOptions.map((option) => option.value);

export const carouselButtonSchema = (duplicatedLabels: boolean) =>
  yup.object({
    label: yup
      .string()
      .min(1, () => t('validation.at_least', { 0: 1 }))
      .max(32, () => t('validation.less_than', { 0: 32 }))
      .required(() => t('validation.required'))
      .test(
        'isDuplicated',
        () => t('dialog.errors.carousel_duplicated_button_label'),
        () => !duplicatedLabels
      ),

    type: yup
      .string()
      .oneOf([...defaultCarouselButtonSelectOptions])
      .required(() => t('validation.required')),
    value: yup.string().when('type', ([type], schema) => {
      // If the type is postback or phone
      if (
        type === defaultCarouselButtonSelectOptions[1] ||
        type === defaultCarouselButtonSelectOptions[3]
      ) {
        return schema
          .max(LENGTH_M, () => t('validation.less_than', { 0: LENGTH_M }))
          .required(() => t('validation.required'));
      }
      return schema.strip();
    }),
    url: yup.string().when('type', ([type], schema) => {
      // If the type is url or webview
      if (
        type === defaultCarouselButtonSelectOptions[0] ||
        type === defaultCarouselButtonSelectOptions[2]
      ) {
        return urlSchema;
      }
      return schema.strip();
    }),
    height: yup.string().when('type', ([type], schema) => {
      // If the type is webview
      if (type === defaultCarouselButtonSelectOptions[2]) {
        return yup
          .string()
          .max(LENGTH_S, () => t('validation.less_than', { 0: LENGTH_S }))
          .required(() => t('validation.required'));
      }
      return schema.strip();
    }),
    trigger_node_id: yup.string().when('type', ([type], schema) => {
      // If the type is webview
      if (type === defaultCarouselButtonSelectOptions[2]) {
        return yup
          .string()
          .min(2, () => t('validation.at_least', { 0: 2 }))
          .max(LENGTH_S, () => t('validation.less_than', { 0: LENGTH_S }))
          .matches(slug)
          .required(() => t('validation.required'));
      }
      return schema.strip();
    }),
    auto_open: yup.boolean().when('type', ([type], schema) => {
      if (type === defaultCarouselButtonSelectOptions[2]) {
        return schema;
      }
      return schema.strip();
    }),
  });
